import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { startTransition } from 'react';
import { useNavigate } from 'react-router-dom';
import Faq from 'src/components/Faq/Faq';
import '../../CSS/Faq.css';

export default function Faqs() {
  const navigate = useNavigate();

  const sampleFAQ = [
    {
      id: 1,
      question: 'What is 4DPS?',
      answer:
        "4DPS is a comprehensive platform built for Amazon Delivery Service Partners (DSPs). It helps DSP owners and managers streamline their daily operations — from managing Delivery Associates (DAs) and tracking routes to monitoring performance metrics and staying compliant with Amazon's standards.",
    },
    {
      id: 2,
      question: 'What is a DSP?',
      answer:
        'A DSP (Delivery Service Partner) is an independent small business owner who partners with Amazon to deliver packages. DSPs operate their own fleet of delivery vans and employ a team of Delivery Associates (DAs) to fulfill last-mile deliveries on behalf of Amazon.',
    },
    {
      id: 3,
      question: 'What is a DA?',
      answer:
        'A DA (Delivery Associate) is a driver employed by a DSP to deliver Amazon packages. DAs are the boots on the ground — they load their vans, follow assigned routes, and ensure packages reach customers safely and on time. 4DPS gives DSP managers full visibility into their DA workforce.',
    },
    {
      id: 4,
      question: 'How does 4DPS help manage Delivery Associates?',
      answer:
        '4DPS provides tools to onboard, schedule, and monitor your DAs in one place. Managers can track attendance, assign routes, review performance scorecards, flag compliance issues, and communicate with their team — reducing the administrative overhead that comes with running a DSP.',
    },
    {
      id: 5,
      question: "Can 4DPS help improve my DSP's Amazon performance score?",
      answer:
        "Yes. 4DPS surfaces key delivery metrics and DA performance data aligned with Amazon's Delivery Service Partner scorecard. By identifying issues early — such as missed deliveries, late departures, or safety incidents — managers can take corrective action before scores are impacted.",
    },
    {
      id: 6,
      question: 'Is there a customer support team available?',
      answer:
        "Absolutely. Our support team is available 24/7 to help you get the most out of 4DPS. Whether you're onboarding your first DAs or troubleshooting a reporting issue, we're here to make sure your DSP operations run without a hitch.",
    },
  ];

  return (
    <div className="faq-page">
      <button
        className="faq-close-btn"
        onClick={() => startTransition(() => navigate(-1))}
        aria-label="Close"
      >
        <FontAwesomeIcon icon={faXmark} size="sm" />
      </button>

      <div className="faq-header">
        <img className="faq-logo" src="4DSPS_White.png" alt="4DPS logo" />
        <div className="faq-eyebrow">Support</div>
        <h2>FAQs</h2>
        <p>Your questions answered here.</p>
      </div>

      <div className="faq-list">
        {sampleFAQ.map((faq) => (
          <Faq key={faq.id} {...faq} defaultOpen={faq.id === 1} />
        ))}
      </div>
    </div>
  );
}
